package br.com.vvrefeicoes.portal.core.model

sealed interface AppError {
    data object Network : AppError

    data object Unauthorized : AppError

    data object NotFound : AppError

    /** O recurso existia, mas passou da validade (HTTP 410). */
    data object Expired : AppError

    data object TooManyAttempts : AppError

    data class Unexpected(
        val message: String? = null,
        val cause: Throwable? = null,
    ) : AppError
}
